import { cn } from "@/utils/helpers/utils"

import { VariantProps, cva } from "class-variance-authority"
import { ButtonHTMLAttributes, ForwardedRef, forwardRef } from "react"
import styles from "./GradientButton.module.css" // Import CSS module

// Customized button variations
export const buttonVariants = cva(
   `focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandOrange   rounded inline-flex items-center  justify-center transition-all
  `,
   {
      variants: {
         size: {
            xs: "px-2 py-1 text-xs gap-x-1.5",
            sm: "px-2 py-1 text-sm gap-x-1.5",
            md: "rounded-[10px] px-2.5 py-1.5 text-sm gap-x-1.5",
            lg: "rounded-[10px] px-3 py-2 text-sm gap-x-2",
            xl: "rounded-[10px] px-3.5 py-3 text-sm gap-x-2",
            "2xl": "rounded-[10px] px-4 py-3 text-base md:text-2xl gap-x-2",
         },
         variant: {
            primary: "text-white bg-brandOrange hover:brightness-110 focus-visible:outline-brandOrange",
            gradient: `${styles.gradientButton}`,
            gradientColor: `${styles.btnGrad}`,
            outline:
               "flex flex-1 items-center justify-center gap-2 rounded-md border border-black bg-white px-3 py-2 text-base  text-black hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-offset-2",
            soft: "bg-indigo-50 text-indigo-600 hover:bg-indigo-100 focus-visible:outline-indigo-100",
            ghost: "bg-transparent text-gray-900 hover:bg-orange-50 focus-visible:outline-orange-300",
            link: "focus-visible:outline-brandOrange font-semibold leading-6 text-brandOrange hover:brightness-110        shadow-none",
         },
         pill: {
            true: "rounded-full",
            false: "",
         },
      },
      defaultVariants: {
         size: "xl",
         variant: "primary",
         pill: false,
      },
   },
)

// ButtonProps interface
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
   ({ size, variant, pill, type, className, children, ...props }, ref: ForwardedRef<HTMLButtonElement>) => {
      return (
         <button ref={ref} type={type} className={cn(buttonVariants({ className, variant, size, pill }))} {...props}>
            {children}
         </button>
      )
   },
)

Button.displayName = "Button"

export default Button
